/**
 * Compare two dotted firmware strings (e.g. 1.12.2).
 * Returns -1 if versionA < versionB, 0 if equal, 1 if versionA > versionB.
 */
export const compareFirmwareVersions = (
	versionA: string | undefined | null,
	versionB: string | undefined | null,
): number => {
	const partsA: number[] = parseFirmwareVersionParts(versionA);
	const partsB: number[] = parseFirmwareVersionParts(versionB);
	const maxParts: number = Math.max(partsA.length, partsB.length);
	for (let i = 0; i < maxParts; i++) {
		const numA: number = partsA[i] ?? 0;
		const numB: number = partsB[i] ?? 0;
		if (numA < numB) {
			return -1;
		}
		if (numA > numB) {
			return 1;
		}
	}
	return 0;
};

/**
 * Split a firmware string into numeric segments (X.Y.Z → [X, Y, Z]).
 * Non-numeric segments become 0; null/empty → [].
 */
export const parseFirmwareVersionParts = (rawVersion: string | undefined | null): number[] => {
	if (rawVersion == null) {
		return [];
	}
	const trimmed: string = String(rawVersion).trim();
	if (trimmed === '') {
		return [];
	}
	return trimmed.split('.').map(segment => {
		const parsed: number = parseInt(segment, 10);
		return Number.isFinite(parsed) ? parsed : 0;
	});
};
